import { Component, OnInit, OnDestroy } from '@angular/core';
import {ActivatedRoute, Router, Params } from '@angular/router';
import { BlogService } from '../../services/blog.service';
import { CommonService } from '../../services/common.service';
@Component({
  selector: 'app-breeddetails',
  templateUrl: './breeddetails.component.html',
  styleUrls: ['./breeddetails.component.css']
})
export class BreeddetailsComponent implements OnInit {
breedinfo: any;
did: number;
public data;
show = false;
 public loading = false;
  constructor(private route: ActivatedRoute, private blogService: BlogService) {
    this.route.params.subscribe(params => {
      const id = +params['id'];
      this.did = id;
       });
  }

  ngOnInit() {
     this.loading = true;
    this.getBreedinfo();
  }

  getBreedinfo() {
    this.blogService.getBreedInfoDetails(this.did)
    .subscribe(
      (y) => {
        this.loading = false;
        this.breedinfo = y;
      });
    }
}
